// BUG & ERROR
import BugReport from '@/core/pages/BugReport.vue';
import ErrorPage from '@/core/pages/ErrorPage.vue';

// CLUSTERS
import Clusters from '@/modules/clusters/ClustersIndex.vue';
import CLUSTER_ROUTES from '@/modules/clusters/routes';

// EMPLOYERS
import Employers from '@/modules/employers/EmployersIndex.vue';
import EMPLOYER_ROUTES from '@/modules/employers/routes';

// COMPANIES
import Companies from '@/modules/companies/CompaniesIndex.vue';
import COMPANY_ROUTES from '@/modules/companies/routes';

// JOB FUNCTIONS
import InternalJobFunctions from '@/modules/internal-job-functions/InternalJobFunctionsIndex.vue';
import INTERNAL_JOB_FUNCTION_ROUTES from '@/modules/internal-job-functions/routes';
import JobFunctions from '@/modules/job-functions/JobFunctionsIndex.vue';
import JOB_FUNCTION_ROUTES from '@/modules/job-functions/routes';

// TEAMS
import TEAM_ROUTES from '@/modules/teams/routes';
import Teams from '@/modules/teams/TeamsIndex.vue';

// TENATNS
import TENANT_ROUTES from '@/modules/tenants/routes';
import Tenants from '@/modules/tenants/TenantsIndex.vue';

// USERS
import USER_ROUTES from '@/modules/users/routes';
import Users from '@/modules/users/UsersIndex.vue';

import AppPrivate from '@/AppPrivate.vue';
import { NXT_AUTH_GUARD } from '@nxtpeople/nxt-vue-keycloak';
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import AUTH_GUARD from './guard/auth.guard';

export const privateRoutes: Array<RouteRecordRaw> = [
   {
      path: '',
      redirect: { name: 'UsersOverview' },
   },
   {
      path: '/users',
      name: 'Users',
      component: Users,
      children: USER_ROUTES,
   },
   {
      path: '/teams',
      name: 'Teams',
      component: Teams,
      children: TEAM_ROUTES,
   },
   {
      path: '/clusters',
      name: 'Clusters',
      component: Clusters,
      children: CLUSTER_ROUTES,
   },
   {
      path: '/internal-job-functions',
      name: 'InternalJobFunctions',
      component: InternalJobFunctions,
      children: INTERNAL_JOB_FUNCTION_ROUTES,
   },
   {
      path: '/job-functions',
      name: 'JobFunctions',
      component: JobFunctions,
      children: JOB_FUNCTION_ROUTES,
   },
   {
      path: '/tenants',
      name: 'Tenants',
      component: Tenants,
      children: TENANT_ROUTES,
      meta: { permissions: 'tenants' },
   },
   {
      path: '/employers',
      name: 'Employers',
      component: Employers,
      children: EMPLOYER_ROUTES,
      // meta: { permissions: 'employers' },
   },
   {
      path: '/companies',
      name: 'Companies',
      component: Companies,
      children: COMPANY_ROUTES,
      meta: { permissions: 'tenants' },
   },
   {
      path: '/bug-report',
      name: 'BugReport',
      component: BugReport,
   },
];

export const publicRoutes: Array<RouteRecordRaw> = [
   {
      path: '/error',
      name: 'ErrorPage',
      component: ErrorPage,
   },
   {
      path: '/unavailable',
      name: 'Unavailable',
      component: () => import('@/core/pages/Unavailable.vue'),
   },
];

const router = createRouter({
   history: createWebHistory(import.meta.env.BASE_URL),
   routes: [
      {
         path: '/',
         name: 'AppPrivate',
         component: AppPrivate,
         children: privateRoutes,
         redirect: { name: 'board-overview' },
      },
      ...publicRoutes,
      {
         path: '/:pathMatch(.*)*',
         name: 'redirect',
         redirect: { name: 'board-overview' },
      },
   ],
});

// Authentication guard
router.beforeEach((to, from, next) => NXT_AUTH_GUARD(to, from, next, { privateRoutes }));

// Authorization guard
router.beforeEach(AUTH_GUARD);

export default router;
